<script>
import { mapActions } from "vuex";
import Wallet from "@/components/_Shared/Wallet";
import Autocomplete from "@/components/_Shared/Autocomplete";

export default {
  props: {
    label: {
      type: String,
      required: true,
      default: "professional"
    }
  },

  components: {
    Wallet,
    Autocomplete
  },

  data() {
    return {
      preloader: false,
      selected: {
        wallet: { id: "" },
        paymentGatewayAccount: { id: "" },
        account: { id: "" }
      },
      list: []
    };
  },

  methods: {
    ...mapActions("professionals", ["searchByName"]),

    async search(filter) {
      this.preloader = true;

      if (!filter || filter.lenght <= 3) {
        this.preloader = false;
        return;
      }

      const filters = [{ name: "text_search", value: filter }];

      let includes = ["payment_gateway_account.wallet"];

      try {
        let response = await this.searchByName({ filters, includes });
        this.list = response["data"];
      } catch (error) {
        throw error;
      }

      this.preloader = false;
    },

    select(account) {
      this.selected = {
        wallet: { id: account.payment_gateway_account.wallet.id },
        paymentGatewayAccount: { id: account.payment_gateway_account.id },
        account: { id: account.id, email: account.email }
      };
      this.$emit("selected", this.selected);
      this.list = [];
    },

    clear() {
      this.selected = null;
      this.list = [];
      this.$emit("clear");
    }
  }
};
</script>

<template>
  <v-layout align-center justify-start column fill-height class="box">
    <v-layout row>
      <Autocomplete
        :label="this.label"
        :results="list"
        :preloader="preloader"
        :labels="['first_name', 'last_name']"
        :separators="[' ', ' ']"
        @search="search"
        @select="select"
        @clear="clear"
      />
    </v-layout>
    <v-layout class="transfer-wallet">
      <Wallet
        v-if="selected.wallet.id"
        :walletId="this.selected.wallet.id"
        :withDraw="false"
        :owner="this.selected"
      />
    </v-layout>
  </v-layout>
</template>

<style scoped>
.title {
  font-size: 14px;
}
.transfer-wallet {
  margin-left: -40%;
}

@media (max-width: 480px) {
  .transfer-wallet {
    margin-left: 0%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Transfers/NewTransfer/Wallet.vue